import { ComplaintActionModel } from "../../models/complaints/complaint-model";
import * as XLSX from 'xlsx';

export const complaintActionsExport = (
  actionList: ComplaintActionModel[], 
  complaintType: 'product' | 'service'
) => {
  const exportData = prepareExportData(actionList, complaintType);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  XLSX.utils.book_append_sheet(wb, ws, 'ComplaintActions');
  XLSX.writeFile(wb, `ComplaintActionsExport_${new Date().toISOString().split('T')[0]}.xlsx`);
};

const formatDateSafely = (date: any) => {
  if (!date) return "";
  const parsed = new Date(date);
  return isNaN(parsed.getTime())
    ? ""
    : parsed.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
};

const prepareExportData = (
  actionList: ComplaintActionModel[],
  complaintType: 'product' | 'service'
) => {
  return actionList.map((action) => {
    const baseFields = {
      'Action Date': formatDateSafely(action.actionDate),
      'Description': action.description || "",
      'Corrective Action': action.correctiveAction || "",
      'Preventive Action': action.preventiveAction || "",
      'Severity': action.severity || "",
      'Status': action.statusName || "",
      'Action By': action.actionByName || "",
      'COPQ (₹)': action.copqInRs?.toFixed(2) || "0.00",
      'Remarks': action.remarks || ""
    };

    // Add type-specific fields
    if (complaintType === 'product') {
      return {
        ...baseFields,
        'Product Complaint ID': action.productComplaintId || ""
      };
    } else {
      return {
        ...baseFields,
        'Service Complaint ID': action.serviceComplaintId || ""
      };
    }
  });
};